import { classNames } from '@utils/class-names';
import React from 'react';
export const SectionTitle = ({ children, className }) => {
    return (React.createElement("div", { className: classNames('font-medium text-sm text-darkBlue/70', className) }, children));
};
